export default "__VITE_ASSET__BGzHn$Kr__"